import axiosIns from "@/libs/axios";
import api from "@/libs/api";
import { getLocalStorage, setLocalStorage } from '../storage';
import router from "../../router";

export const state = {
    currencies: [],
    selectedCurrency: null,
    isLoading: false,
    error: null
};

export const getters = {
    currencies: (state) => state.currencies,
    selectedCurrency: (state) => state.selectedCurrency,
    selectedTimezone: (state) => state.selectedCurrency?.country?.timezone?.gmt || '+08:00',
    isLoading: state => state.isLoading,
    error: state => state.error
};

export const mutations = {
    SET_CURRENCIES(state, currencies) {
        state.currencies = currencies
    },
    SET_SELECTED_CURRENCY(state, currency) {
        state.selectedCurrency = currency
        setLocalStorage('selectedCurrency', currency.code, 7);
    },
    SET_LOADING(state, isLoading) {
        state.isLoading = isLoading;
    },
    SET_ERROR(state, error) {
        state.error = error;
    },
    CLEAR_CONFIG(state) {
        state.currencies = [];
        state.selectedCurrency = null;
        state.isLoading = false;
        state.error = null;
    }
};

export const actions = {
    async fetchConfig({ commit }) {
        commit("SET_LOADING", true);
        commit("SET_ERROR", null);

        try {
            const response = await axiosIns.get(api.API_CONFIG); // calls /api/config
            const { currencies } = response.data.data

            commit('SET_CURRENCIES', currencies)

            // Try to load saved currency from local storage
            const savedCurrency = getLocalStorage('selectedCurrency')
            if (savedCurrency) {
                const matched = currencies.find(currency => currency.code === savedCurrency)
                if (matched) {
                    commit('SET_SELECTED_CURRENCY', matched)
                } else {
                    commit('SET_SELECTED_CURRENCY', currencies[0])
                }
            } else if (currencies.length > 0) {
                commit('SET_SELECTED_CURRENCY', currencies[0])
            }
        } catch (error) {
            commit("SET_ERROR", error.message || "Failed to fetch config");
            throw error;
        } finally {
            commit("SET_LOADING", false);
        }
    },

    clearConfig({ commit }) {
        commit("CLEAR_CONFIG");
    },

    async switchCurrency({ state, commit, dispatch }, selectedCurrencyCode) {
        const currency = state.currencies.find(c => c.code === selectedCurrencyCode)
        if (!currency) throw new Error('Invalid selected currency')

        commit('SET_SELECTED_CURRENCY', currency);

        // Refresh config to get updated currencies
        await dispatch('fetchConfig')
            .catch(() => {})
            .finally(
                // Soft reload current route
                router.replace({
                    path: router.currentRoute.value.path,
                    query: {
                        ...router.currentRoute.value.query,
                        t: Date.now(), // dummy param to trigger reload
                    },
                }));

        // Refresh to get updated notifications
        await dispatch('notification/forceRefresh', null, { root: true });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}